import React from 'react'
import './Work.css'

const Work = () => (
  <div className='work animated fadeIn'>
    <div className='work-inner'>
      <div className='work-section'>
        <h2 className='section-header'>Coming Soon</h2>
        <div className='section-content'>
          This page is under construction!
        </div>
      </div>
    </div>
  </div>
)

export default Work